import React from "react";
import { array, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import StoryMetaData from "../../molecules/StoryMetaData";

import { staticTexts } from "../../utils/Translate";
import { getStoryHeadline } from "../../utils/utils";

import "./latestStories.m.css";

const LatestStories = ({ story, stories, publisherAttributes }) => {
  const relText =
    story && story["story-template"] === "photo"
      ? staticTexts(publisherAttributes.lang).morePhotoStories
      : staticTexts(publisherAttributes.lang).relatedStories;
  return (
    <div styleName="latest-stories">
      <Headline
        text={relText}
        headerLevel={3}
        headlineType={3}
        className={`heading ${publisherAttributes.lang === "en" ? "en-heading" : ""}`}
      />
      <div styleName="story-container">
        {stories.map((story, index) => {
          const storyHeadline = getStoryHeadline(story);

          return (
            <div key={index}>
              <Link href={story.url}>
                <CardImage
                  story={story}
                  defaultWidth={300}
                  aspectRatio={global.deviceWidth < 876 ? [3, 2] : [16, 9]}
                  imageType={global.deviceWidth < 876 ? "image3x2" : "image16x9"}
                  widths={global.deviceWidth < 876 ? [120] : [300]}
                  showAlternateImage={true}
                />
              </Link>

              <div styleName="story-title">
                {story.subheadline && (
                  <Link href={story.url}>
                    <Headline text={story.subheadline} headerLevel={2} className="section-name" />
                  </Link>
                )}
                <Link href={story.url}>
                  <Headline
                    text={storyHeadline}
                    headlineType={21}
                    headerLevel={2}
                    className={`story-headline ${publisherAttributes.lang === "en" ? "story-headline-en" : ""}`}
                  />
                </Link>
              </div>
              <StoryMetaData story={story} updatedFont={true} publisherLang={publisherAttributes.lang} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

LatestStories.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
  story: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(LatestStories);
